<div class="pt-4 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_members">
  <h2>You do not have permission to manage this inbox.</h2>
</div>

<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-4 pl-md-4 mb-6" *ngIf="serverError === null">
  <div class="row">
    <div class="col">
      <p class="text-center w-100 mb-2"><b>
        Potential Duplicate Customers
        <span *ngIf="inboxResponse">
          ({{ inboxResponse.count }})
        </span>
      </b></p>
    </div>
  </div>

  <div class="alert customer-alert text-center" role="alert"
       [class.alert-success]="modalResult.status === CallbackResultStatus.success"
       *ngIf="modalResult !== null">
    {{ modalResult.text }}
  </div>

  <select class="custom-select w-auto mb-2"
          [(ngModel)]="filters.status"
          (ngModelChange)="reloadSubject.next()">
    <option [ngValue]="PotentialDuplicateCustomerStatus.pendingAction">
      Status: Pending Action
    </option>
    <option [ngValue]="PotentialDuplicateCustomerStatus.merged">
      Status: Merged
    </option>
    <option [ngValue]="PotentialDuplicateCustomerStatus.dismissed">
      Status: Dismissed
    </option>
  </select>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Timestamp</th>
        <th scope="col">New Customer</th>
        <th scope="col">Existing Customer</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingInbox && resultsPresent()">
      <tr *ngFor="let dup of inboxResponse.results">
        <td>
          {{ timeStringFromISO8601(dup.created_at, orgConfig.getOrganizationConfig().time_zone) }},
          {{ dateStringFromISO8601(dup.created_at, orgConfig.getOrganizationConfig().time_zone) }}
        </td>
        <td>
          <a *ngIf="dup.status !== PotentialDuplicateCustomerStatus.merged"
             [routerLink]="['/customers', dup.new_customer_id.toString()]"
             target="_blank">
            {{ dup.new_customer_first_name }}
            {{ dup.new_customer_last_name }}
          </a>
          <span *ngIf="dup.status === PotentialDuplicateCustomerStatus.merged">
            {{ dup.new_customer_first_name }}
            {{ dup.new_customer_last_name }}
          </span>
        </td>
        <td>
          <a [routerLink]="['/customers', dup.existing_customer_id.toString()]"
             target="_blank">
            {{ dup.existing_customer_first_name }}
            {{ dup.existing_customer_last_name }}
          </a>
        </td>
        <td class="table-btn-sm text-right">
          <button class="btn btn-outline-primary btn-sm" style="min-width: 120px"
                  (click)="openModal(dup);$event.preventDefault();">
            <ng-container *ngIf="dup.status === PotentialDuplicateCustomerStatus.pendingAction">
              Review
            </ng-container>
            <ng-container *ngIf="dup.status !== PotentialDuplicateCustomerStatus.pendingAction">
              View
            </ng-container>
          </button>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingInbox || !resultsPresent()">
      <tr>
        <td colspan="99" *ngIf="loadingInbox">
          Loading...
        </td>
        <td colspan="99" *ngIf="!loadingInbox">
          No potential duplicate customers.
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="potentialDuplicateCustomersPageSize"
              (change)="pageNumber = 1;reloadSubject.next();">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="pageNumber = pageNumber - 1;reloadSubject.next();">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="pageNumber = pageNumber - 2;reloadSubject.next();">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="pageNumber = pageNumber - 1;reloadSubject.next();">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="pageNumber = pageNumber + 1;reloadSubject.next();">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="pageNumber = pageNumber + 2;reloadSubject.next();">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="pageNumber = pageNumber + 1;reloadSubject.next();">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>

</div>
